module.exports = __webpack_public_path__ + "img/bk-right-shop-1920.57f39c1e.jpg";